import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { mockData } from '../mock';

export const useMenu = () => {
  const [menu, setMenu] = useState(mockData.currentMenu);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { getAuthHeader } = useAuth();

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const API = `${BACKEND_URL}/api`;

  const fetchMenu = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/menu/current`);
      setMenu(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch menu:', err);
      // Fallback to mock data if API fails
      setMenu(mockData.currentMenu);
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  const updateMenu = async (updatedMenu) => {
    try {
      const response = await axios.put(
        `${API}/menu/current`,
        updatedMenu,
        { headers: getAuthHeader() }
      );
      setMenu(response.data);
      return { success: true };
    } catch (err) {
      console.error('Failed to update menu:', err);
      return { 
        success: false, 
        error: err.response?.data?.detail || 'Erreur lors de la mise à jour' 
      };
    }
  };

  useEffect(() => {
    fetchMenu();
  }, []);

  return {
    menu,
    loading,
    error,
    updateMenu,
    refetchMenu: fetchMenu
  };
};